// import LegalPageLayout from "../../components/LegalPageLayout/LegalPageLayout";
import LegalPageLayout from "../../components/elements/legal-page-layout";

const toc = [
  { id: "aceite", label: "Aceitação" },
  { id: "servicos", label: "Serviços" },
  { id: "usuario", label: "Responsabilidades" },
  { id: "conteudo", label: "Conteúdo educacional" },
  { id: "propriedade", label: "Propriedade intelectual" },
  { id: "encerramento", label: "Suspensão e encerramento" },
];

export default function UseTerms() {
  return (
    <LegalPageLayout
      eyebrow="Regras de utilização"
      title="Termos de Uso"
      description="As condições gerais para acesso ao site, aos materiais e aos serviços educacionais do Escrita & Prática."
      toc={toc}
    >
      <div className="ep-note">
        <p>
          <strong>Última atualização:</strong> 08 de setembro de 2026.
          Modelo sujeito a revisão jurídica antes da publicação.
        </p>
      </div>

      <h2 id="aceite">1. Aceitação dos termos</h2>
      <p>
        Ao acessar o site ou utilizar os serviços do Escrita & Prática, o
        usuário declara que leu e compreendeu estes Termos de Uso. Caso não
        concorde com alguma disposição, deverá interromper a utilização dos
        serviços.
      </p>

      <h2 id="servicos">2. Sobre os serviços</h2>
      <p>
        O Escrita & Prática oferece serviços educacionais, incluindo aulas,
        mentorias, correções de redação e preparação para avaliações e
        concursos, conforme a modalidade contratada.
      </p>

      <h2 id="usuario">3. Responsabilidades do usuário</h2>
      <ul>
        <li>Fornecer informações corretas e atualizadas;</li>
        <li>Utilizar o site e os materiais de maneira lícita;</li>
        <li>Respeitar horários, prazos e orientações pedagógicas;</li>
        <li>Não compartilhar indevidamente materiais protegidos;</li>
        <li>Não utilizar os serviços para atividades fraudulentas ou ilícitas.</li>
      </ul>

      <h2 id="conteudo">4. Conteúdo educacional</h2>
      <p>
        Os materiais fornecidos destinam-se ao uso educacional do aluno
        contratado. O desempenho em provas, concursos ou processos seletivos
        depende de diversos fatores e não representa resultado garantido.
      </p>

      <h2 id="propriedade">5. Propriedade intelectual</h2>
      <p>
        Textos, materiais didáticos, identidade visual, marca, layout,
        elementos gráficos e demais conteúdos disponibilizados pelo Escrita &
        Prática são protegidos pela legislação aplicável. É proibida a
        reprodução comercial ou distribuição sem autorização.
      </p>

      <h2>6. Serviços e links de terceiros</h2>
      <p>
        O site poderá utilizar ferramentas ou links de terceiros. O Escrita &
        Prática não se responsabiliza por alterações ou indisponibilidade de
        serviços externos.
      </p>

      <h2 id="encerramento">7. Suspensão e encerramento</h2>
      <p>
        O acesso poderá ser suspenso ou encerrado em caso de violação destes
        termos, uso indevido, fraude ou outras situações previstas na
        legislação ou no contrato aplicável.
      </p>

      <h2>8. Alterações</h2>
      <p>
        Estes termos poderão ser atualizados. A versão publicada nesta página
        será considerada a versão vigente, observados os direitos já
        constituídos.
      </p>
    </LegalPageLayout>
  );
}